module.exports = __webpack_public_path__ + "assets/img/TLXD-5.13d29f30.jpg";